import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  computed,
  inject,
  signal,
} from '@angular/core';
import { PdfViewerHeaderComponent } from '../pdf-viewer-header/pdf-viewer-header.component';
import { PdfViewerPageComponent } from '../pdf-viewer-page/pdf-viewer-page.component';
import { PdfService } from '../../services/pdf.service';

@Component({
  selector: 'et-pdf-viewer-container',
  imports: [PdfViewerHeaderComponent, PdfViewerPageComponent],
  providers: [PdfService],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerComponent implements OnInit {
  private pdfService = inject(PdfService);

  @Input({ required: true }) file!: File;
  @Input() maxPageHeight = '100%';
  /** 1-based page to open when the viewer loads. Defaults to 1. */
  @Input() initialPage = 1;

  page = signal<number>(1);
  showOverlay = signal<boolean>(false);
  totalPages = computed(() => this.pdfService.totalPages());

  ngOnInit(): void {
    const start = Number.isFinite(this.initialPage) ? this.initialPage : 1;
    if (start !== 1) {
      this.page.set(start);
    }
  }
}
